"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var moment = require("moment");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var diaryCurrentEntryActions = require("@caddigital/sok-reducers/lib/actions/diaryentries/current");
var diaryEntriesActions = require("@caddigital/sok-reducers/lib/actions/diaryentries/list");
var diaryentries_1 = require("@caddigital/sok-reducers/lib/actions/diaryentries");
var diaryActions = require("@caddigital/sok-reducers/lib/actions/sokosite/current");
var toastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var fileActions = require("@caddigital/sok-reducers/lib/actions/files");
var diaryEntryJobsActions = require("@caddigital/sok-reducers/lib/actions/diaryentries/jobs");
var translate_1 = require("utils/translate");
var Types = require("types");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var formatSize_1 = require("utils/helpers/formatSize");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var Comments_1 = require("./Comments");
var UploadModal_1 = require("./Modals/UploadModal");
var sokositeEntryAttachments_1 = require("actions/sokositeEntryAttachments");
var WorksiteStatus_1 = require("./WorksiteStatus");
var WeatherSection_1 = require("./WeatherSection");
require("./style.scss");
var Images_1 = require("./Images");
var Attachments_1 = require("./Attachments");
var NewInputModal_1 = require("./Modals/NewInputModal");
var CountInput_1 = require("./CountInput");
var EditInputModal_1 = require("./Modals/EditInputModal");
var viewport_1 = require("reducers/viewport");
var NotFoundPlaceHolder_1 = require("components/NotFoundPlaceHolder");
var CardBox_1 = require("components/CardBox");
var ListContainer_1 = require("../DiaryEntriesView/ListContainer");
var NavigateConfirmation_1 = require("components/NavigateConfirmation");
var Modal_1 = require("components/modals/Modal");
var mapStateToProps = function (state, ownProps) {
    return {
        fetchStatus: state.diaryentries.current.status,
        currentWorksiteDiary: state.sokosite.current.worksiteDiary,
        currentEntry: state.diaryentries.current.currentEntry,
        updateProgress: state.diaryentries.current.status,
        currentEntryJobs: state.diaryentries.jobs,
        isMobile: (0, viewport_1.isMobile)(state.viewport),
        viewport: state.viewport,
        filesCrudStatus: state.files.filesFolderProperties.status,
        attachmentsStatus: state.diaryentries.current.entryFolder.status,
        attachments: state.diaryentries.current.entryFolder.files.filter(function (attachment) {
            return !(attachment.type === 'FOLDER' && attachment.name === 'images');
        }),
        imagesStatus: state.diaryentries.current.imagesFolder.status,
        images: state.diaryentries.current.imagesFolder.files.filter(function (attachment) { return attachment.type === 'IMAGE'; })
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetchCurrentEntry: function (diaryUuid, entryUuid) {
        return dispatch(diaryCurrentEntryActions.fetchRequest(diaryUuid, entryUuid));
    },
    updateEntry: function (body) {
        return dispatch(diaryCurrentEntryActions.updateEntryRequest(body));
    },
    fetchCurrentDiary: function (diaryUuid) {
        return dispatch(diaryActions.fetchRequest(diaryUuid));
    },
    addNewToast: function (title, message, type) {
        return dispatch(toastActions.addNewToast(title, message, type));
    },
    clearState: function () { return dispatch(diaryCurrentEntryActions.clear()); },
    deleteEntry: function (diaryUuid, entryUuid) {
        return dispatch(diaryEntriesActions.deleteEntry(diaryUuid, entryUuid));
    },
    fetchEntryFiles: function (folderId) {
        dispatch(diaryentries_1.EntryFolderListActions.fetchRequest(folderId, {
            sortBy: null,
            order: 'desc',
            limit: 350,
            offset: 0
        }));
    },
    fetchImagesFiles: function (folderId) {
        dispatch(diaryentries_1.ImagesFolderListActions.fetchRequest(folderId, {
            sortBy: null,
            order: 'desc',
            limit: 350,
            offset: 0
        }));
    },
    deleteFiles: function (items) {
        return dispatch(fileActions.PropertiesActions.deleteRequest(items));
    },
    toggleUploadModal: function () { return dispatch(sokositeEntryAttachments_1.default.toggleModalStatus()); },
    toggleUploadReplace: function (replace) {
        return dispatch(sokositeEntryAttachments_1.default.toggleReplace(replace));
    },
    toggleUnzip: function (unzip) { return dispatch(sokositeEntryAttachments_1.default.toggleUnzip(unzip)); },
    fetchJobs: function (diaryUuid, entryUuid) {
        return dispatch(diaryEntryJobsActions.fetchRequest(diaryUuid, entryUuid));
    },
    postJobs: function (diaryId, entryId, jobs) {
        dispatch(diaryEntryJobsActions.createJobsRequest(diaryId, entryId, jobs));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var fetchAllData = function (props) {
    props.fetchCurrentDiary(props.match.params.id);
    props.fetchCurrentEntry(props.match.params.id, props.match.params.uuid);
    props.fetchJobs(props.match.params.id, props.match.params.uuid);
    if (props.currentEntry && props.currentEntry.folder_id) {
        props.fetchEntryFiles(props.currentEntry.folder_id);
    }
    if (props.currentEntry && props.currentEntry.images_folder_id) {
        props.fetchImagesFiles(props.currentEntry.images_folder_id);
    }
    if (props.currentEntry &&
        props.currentEntry.folder &&
        props.currentEntry.folder.type === 'FOLDER') {
        props.setUploadFolder(props.currentEntry.folder);
    }
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('entryFields', 'setEntryFields', undefined), (0, recompose_1.withState)('uploadFolder', 'setUploadFolder', undefined), (0, recompose_1.withState)('confirmDialogOpen', 'setConfirmDialogOpen', false), (0, recompose_1.withState)('jobsList', 'setJobsList', []), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        fetchAllData(this.props);
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.match.params.uuid !== prevProps.match.params.uuid) {
            fetchAllData(this.props);
        }
        if (this.props.currentEntryJobs !== prevProps.currentEntryJobs) {
            this.props.setJobsList(this.props.currentEntryJobs.jobs);
        }
    },
    componentWillReceiveProps: function (nextProps) {
        if (nextProps.currentEntry &&
            (this.props.currentEntry && this.props.currentEntry.folder_id) !==
                nextProps.currentEntry.folder_id &&
            typeof nextProps.currentEntry.folder_id === 'number') {
            this.props.fetchEntryFiles(nextProps.currentEntry.folder_id);
        }
        if (nextProps.currentEntry &&
            (this.props.currentEntry &&
                this.props.currentEntry.images_folder_id) !==
                nextProps.currentEntry.images_folder_id &&
            typeof nextProps.currentEntry.images_folder_id === 'number') {
            this.props.fetchImagesFiles(nextProps.currentEntry.images_folder_id);
        }
        if (nextProps.currentEntry &&
            nextProps.currentEntry.folder &&
            nextProps.currentEntry.folder_id !==
                (this.props.currentEntry && this.props.currentEntry.folder_id) &&
            nextProps.currentEntry.folder.type === 'FOLDER') {
            nextProps.setUploadFolder(nextProps.currentEntry.folder);
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.match.params.uuid !== nextProps.match.params.uuid) {
            return true;
        }
        if (this.props.updateProgress !== nextProps.updateProgress) {
            if (nextProps.updateProgress === 'UPDATED' ||
                nextProps.updateProgress === 'FAILEDTOUPDATE') {
                this.props.addNewToast((0, translation_1.getLocalization)("diaryEntryView/updateEntryToastMessage/".concat(nextProps.updateProgress)), '', nextProps.updateProgress === 'FAILEDTOUPDATE' ? 'FAILURE' : 'NORMAL');
            }
            return true;
        }
        if (this.props.currentEntry !== nextProps.currentEntry ||
            this.props.weatherInfo !== nextProps.weatherInfo ||
            this.props.currentProject !== nextProps.currentProject ||
            this.props.currentWorksiteDiary !== nextProps.currentWorksiteDiary ||
            this.props.entryFields !== nextProps.entryFields ||
            this.props.confirmDialogOpen !== nextProps.confirmDialogOpen ||
            this.props.currentEntryJobs !== nextProps.currentEntryJobs ||
            this.props.jobsList !== nextProps.jobsList ||
            this.props.confirmDialogOpen !== nextProps.confirmDialogOpen ||
            this.props.attachments !== nextProps.attachments ||
            this.props.uploadFolder !== nextProps.uploadFolder ||
            this.props.images !== nextProps.images ||
            this.props.viewport !== nextProps.viewport) {
            return true;
        }
        return false;
    },
    componentWillUnmount: function () {
        this.props.clearState();
    }
}), recompose_1.pure);
function getInitialAccordionStateForKey(entry, key) {
    if (!entry) {
        return true;
    }
    var hasValue = !!entry[key];
    var hasForemanSignature = !!entry.master_signature;
    var hasSupervisorSignature = !!entry.supervisor_signature;
    if (hasValue) {
        return true;
    }
    if (!hasSupervisorSignature && key === 'supervisor_notes') {
        return true;
    }
    return !hasForemanSignature;
}
exports.default = enhance(function (props) {
    if (props.fetchStatus === 'FETCHING') {
        return (React.createElement("div", { className: 'worksite-diary-view' },
            React.createElement("div", { className: 'loading' },
                React.createElement(sok_ui_1.LoadingSpinner, null))));
    }
    else if (props.fetchStatus === 'FAILED') {
        return (React.createElement("div", { className: 'worksite-diary-view' },
            React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { className: "no-entry", key: "no-entry", title: "diaryEntriesView/emptyList/title", message: "diaryEntryView/emptyList/message" })));
    }
    var _a = React.useState(), imagePropertiesFile = _a[0], setImagePropertiesFile = _a[1];
    var _b = React.useState(false), showEquipment = _b[0], setShowEquipment = _b[1];
    var _c = React.useState(false), showEditEquipment = _c[0], setEditEquipment = _c[1];
    var _d = React.useState({}), weatherInfo = _d[0], setWeatherInfo = _d[1];
    var _e = React.useState(false), showEmployee = _e[0], setShowEmployee = _e[1];
    var _f = React.useState(false), showEditEmployee = _f[0], setEditEmployee = _f[1];
    var _g = React.useState([]), employees = _g[0], setEmployees = _g[1];
    var _h = React.useState([]), equipments = _h[0], setEquipments = _h[1];
    var _j = React.useState(), currentInput = _j[0], setCurrentInput = _j[1];
    var _k = React.useState(), acceptFileTypes = _k[0], setAcceptFileTypes = _k[1];
    var _l = React.useState(false), longerEmployees = _l[0], setLongerEmployees = _l[1];
    var _m = React.useState(false), longerEquipments = _m[0], setLongerEquipments = _m[1];
    var selectedLanguage = (0, translate_1.getLanguage)();
    var deleteEntryConfirmData = {
        title: 'diaryEntryView/diaryEntryViewDeleteEntry/pleaseConfirmDeletingEntry',
        text: 'diaryEntryView/diaryEntryViewDeleteEntry/deletingEntryNoticeText',
        onConfirm: function () {
            if (props.currentWorksiteDiary && props.currentEntry) {
                props.deleteEntry(props.currentWorksiteDiary.diary_uuid, props.currentEntry.entry_uuid);
            }
            props.setConfirmDialogOpen(false);
            if (props.currentProject && props.currentWorksiteDiary) {
                props.history.push("/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite/worksitediary/").concat(props.currentWorksiteDiary.diary_uuid, "/entries"));
            }
        }
    };
    var _o = React.useState(deleteEntryConfirmData), confirmDialogData = _o[0], setConfirmDialogData = _o[1];
    React.useEffect(function () {
        if (props.currentEntry) {
            props.setEntryFields(undefined);
            setWeatherInfo(props.currentEntry.weather_info || {});
            if (props.currentEntry.equipment_status) {
                setEquipments(props.currentEntry.equipment_status);
            }
            if (props.currentEntry.employee_status) {
                setEmployees(props.currentEntry.employee_status);
            }
        }
    }, [props.currentEntry]);
    // Check in a CountInput list if it has items that are longer than 32 for styling purposes
    var checkItemLengths = function (list) {
        var tooLong = false;
        list.map(function (item) {
            if (item.name.length > 32) {
                tooLong = true;
            }
        });
        return tooLong;
    };
    React.useEffect(function () {
        props.toggleUploadReplace(false);
        props.toggleUnzip(true);
        setLongerEmployees(checkItemLengths(employees));
        setLongerEquipments(checkItemLengths(equipments));
    }, []);
    React.useEffect(function () {
        setLongerEmployees(checkItemLengths(employees));
    }, [employees]);
    React.useEffect(function () {
        setLongerEquipments(checkItemLengths(equipments));
    }, [equipments]);
    function handleChange(e) {
        var _a;
        var value = e.target.value;
        props.setEntryFields(__assign(__assign({}, props.entryFields), (_a = {}, _a[e.target.name] = value, _a)));
    }
    function addEquipment(input) {
        setEquipments(__spreadArray(__spreadArray([], equipments, true), [input], false));
    }
    function addEmployee(input) {
        setEmployees(__spreadArray(__spreadArray([], employees, true), [input], false));
    }
    function setEquipmentCount(index, count) {
        var newEquipments = __spreadArray([], equipments, true);
        var item = __assign({}, newEquipments[index]);
        item.count = count;
        newEquipments[index] = item;
        setEquipments(newEquipments);
    }
    function setEmployeeCount(index, count) {
        var newEmployees = __spreadArray([], employees, true);
        var item = __assign({}, newEmployees[index]);
        item.count = count;
        newEmployees[index] = item;
        setEmployees(newEmployees);
    }
    function editEquipment(index, name, count, remove) {
        if (remove === true) {
            var newEquipments = __spreadArray([], equipments, true);
            var oldItem_1 = newEquipments[index];
            newEquipments = newEquipments.filter(function (item) { return item !== oldItem_1; });
            setEquipments(newEquipments);
        }
        else {
            var newEquipments = __spreadArray([], equipments, true);
            var item = __assign({}, newEquipments[index]);
            item.name = name;
            item.count = count;
            newEquipments[index] = item;
            setEquipments(newEquipments);
        }
    }
    function editEmployee(index, name, count, remove) {
        if (remove === true) {
            var newEmployees = __spreadArray([], employees, true);
            var oldItem_2 = newEmployees[index];
            newEmployees = newEmployees.filter(function (item) { return item !== oldItem_2; });
            setEmployees(newEmployees);
        }
        else {
            var newEmployees = __spreadArray([], employees, true);
            var item = __assign({}, newEmployees[index]);
            item.name = name;
            item.count = count;
            newEmployees[index] = item;
            setEmployees(newEmployees);
        }
    }
    var perm = props.currentProject && props.currentProject.perm
        ? props.currentProject.perm
        : 0x00;
    var worksiteDiaryPerm = props.currentWorksiteDiary && props.currentWorksiteDiary.perm
        ? props.currentWorksiteDiary.perm
        : 0x00;
    var isDiarySigned = function () {
        return (props.currentEntry &&
            props.currentEntry.master_signature &&
            props.currentEntry.master_signature !== '') ||
            false;
    };
    // Checks for user rights and returns a boolean based on the state of the entry
    // if master has signed, if supervisor has signed etc.
    var disableFieldsHelper = function () {
        return (isDiarySigned() ||
            !(acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT) ||
                acl.hasGrant(worksiteDiaryPerm, acl.WORKSITE_DIARY_MASTER_GRANT)));
    };
    // Checks if save button should be disabled or not.
    var disableSaveButtonHelper = function () {
        if (acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT) ||
            acl.hasGrant(worksiteDiaryPerm, acl.WORKSITE_DIARY_MASTER_GRANT) ||
            acl.hasGrant(worksiteDiaryPerm, acl.WORKSITE_DIARY_SUPERVISOR_GRANT)) {
            if (props.currentEntry) {
                if (isDiarySigned()) {
                    // Both Master and supervisor has signed. Saving is no-longer allowed
                    return true;
                }
                else if (props.entryFields !== undefined ||
                    (weatherInfo &&
                        JSON.stringify(weatherInfo) !== JSON.stringify({}) &&
                        JSON.stringify(weatherInfo) !==
                            (props.currentEntry.weather_info &&
                                JSON.stringify(props.currentEntry.weather_info))) ||
                    JSON.stringify(props.currentEntryJobs.jobs) !==
                        JSON.stringify(props.jobsList)) {
                    // If entryFields, weather info or jobs have been changed
                    return false;
                }
                else if (equipments &&
                    (props.currentEntry.equipment_status
                        ? JSON.stringify(props.currentEntry.equipment_status)
                        : JSON.stringify([])) !== JSON.stringify(equipments)) {
                    // If equipment status has been change
                    return false;
                }
                else if (employees &&
                    (props.currentEntry.employee_status
                        ? JSON.stringify(props.currentEntry.employee_status)
                        : JSON.stringify([])) !== JSON.stringify(employees)) {
                    // If employee status has been changed
                    return false;
                }
            }
        }
        return true;
    };
    var checkFieldsAndUpdateEntry = function (props, signAsMaster, signAsSupervisor) {
        if (props.currentEntry) {
            var updatedEntry = {
                id: props.currentEntry.id,
                diary_uuid: props.currentEntry.diary_uuid,
                entry_uuid: props.currentEntry.entry_uuid,
                weather_info: weatherInfo
            };
            if (signAsMaster) {
                updatedEntry['master_signature'] = 'Master signed the entry';
            }
            if (signAsSupervisor) {
                updatedEntry['supervisor_signature'] = 'Supervisor signed the entry';
            }
            if (props.entryFields) {
                updatedEntry = __assign(__assign({}, updatedEntry), { plan_info: props.entryFields.planInfo, review_info: props.entryFields.reviewInfo, small_critical_changes: props.entryFields.smallChanges, change_offers: props.entryFields.changeOffers, additional_time: props.entryFields.additionalTime, additional_notes: props.entryFields.additionalNotes, supervisor_notes: props.entryFields.supervisorNotes, other_notes: props.entryFields.otherNotes });
            }
            if (equipments) {
                updatedEntry = __assign(__assign({}, updatedEntry), { equipment_status: equipments });
            }
            if (employees) {
                updatedEntry = __assign(__assign({}, updatedEntry), { employee_status: employees });
            }
            if (weatherInfo) {
                updatedEntry = __assign(__assign({}, updatedEntry), { weather_info: weatherInfo });
            }
            if (props.currentEntryJobs && props.jobsList) {
                if (props.currentEntryJobs.jobs !== props.jobsList) {
                    props.postJobs(props.currentEntry.diary_uuid, props.currentEntry.entry_uuid, props.jobsList);
                }
            }
            props.updateEntry(updatedEntry);
            props.setEntryFields(undefined);
            props.setJobsList([]);
        }
    };
    var employeeCount = 0;
    var equipmentsCount = 0;
    employees.map(function (employee) { return (employeeCount += employee.count); });
    equipments.map(function (equipment) { return (equipmentsCount += equipment.count); });
    var menuButtons = (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntryView/footer/button/previous'), color: 'base-blue', type: 'submit', disabled: props.currentEntry && props.currentEntry.previous_entry_uuid
                ? false
                : true, onClick: function (e) {
                if (props.currentProject &&
                    props.currentWorksiteDiary &&
                    props.currentEntry) {
                    // If there's no unsaved changes, reset state variables
                    if (disableSaveButtonHelper()) {
                        props.setEntryFields(undefined);
                        props.setJobsList([]);
                        setWeatherInfo({});
                        setEmployees([]);
                        setEquipments([]);
                    }
                    props.history.push("/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite/worksitediary/").concat(props.currentWorksiteDiary.diary_uuid, "/entries/").concat(props.currentEntry.previous_entry_uuid));
                }
            } }),
        React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntryView/footer/button/next'), color: 'base-blue', type: 'submit', disabled: props.currentEntry && props.currentEntry.next_entry_uuid
                ? false
                : true, onClick: function (e) {
                if (props.currentProject &&
                    props.currentWorksiteDiary &&
                    props.currentEntry) {
                    // If there's no unsaved changes, reset state variables
                    if (disableSaveButtonHelper()) {
                        props.setEntryFields(undefined);
                        props.setJobsList([]);
                        setWeatherInfo({});
                        setEmployees([]);
                        setEquipments([]);
                    }
                    props.history.push("/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite/worksitediary/").concat(props.currentWorksiteDiary.diary_uuid, "/entries/").concat(props.currentEntry.next_entry_uuid));
                }
            } }),
        React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntryView/footer/button/save'), color: 'base-green', type: 'submit', disabled: disableSaveButtonHelper(), onClick: function (e) {
                e.preventDefault();
                checkFieldsAndUpdateEntry(props);
            } }),
        React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntryView/footer/button/close'), color: 'dark-gray', onClick: function () {
                if (props.currentProject && props.currentWorksiteDiary) {
                    props.history.push("/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite/worksitediary/").concat(props.currentWorksiteDiary.diary_uuid, "/entries"));
                }
            } })));
    return (React.createElement(React.Fragment, null,
        imagePropertiesFile && (React.createElement(Modal_1.default, { name: "image-properties", headerLabel: (0, translation_1.getLocalization)('sokosite/entry/image/properties'), isOpen: true, onClose: function () { return setImagePropertiesFile(undefined); }, buttons: [
                {
                    label: (0, translation_1.getLocalization)('sokosite/entry/image/properties/close'),
                    onClick: function () {
                        setImagePropertiesFile(undefined);
                    },
                    color: 'light-gray'
                }
            ] },
            React.createElement("h4", null, (0, translation_1.getLocalization)('sokosite/entry/image/properties/name')),
            imagePropertiesFile.name,
            React.createElement("h4", null, (0, translation_1.getLocalization)('sokosite/entry/image/properties/size')),
            imagePropertiesFile.meta &&
                imagePropertiesFile.meta.size &&
                (0, formatSize_1.formatSize)(imagePropertiesFile.meta.size))),
        props.uploadFolder && (React.createElement(UploadModal_1.default, { folder: props.uploadFolder, multipleFiles: true, uploadButtonLabel: "sokosite/entry/upload", descriptionLabel: "sokosite/entry/uploadDescription", accept: acceptFileTypes })),
        React.createElement("div", { className: 'content-wrapper-content' },
            React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.confirmDialogOpen, close: function () { return props.setConfirmDialogOpen(false); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                    React.createElement(ConfirmDialog_1.Exclamation, null),
                    React.createElement("div", null,
                        React.createElement("div", { className: 'title please-confirm-text' },
                            React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)(confirmDialogData.title))),
                        React.createElement("div", { className: 'text' },
                            React.createElement("p", null, (0, translation_1.getLocalization)(confirmDialogData.text))))), footer: React.createElement(React.Fragment, null,
                    React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: confirmDialogData.onConfirm }),
                    React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setConfirmDialogOpen(false); } })) }),
            React.createElement("div", { className: 'diaryentry-view' },
                props.isMobile && (React.createElement(sok_ui_1.MobileOptionsMenu, null, menuButtons)),
                React.createElement("main", { className: 'content' },
                    React.createElement(sok_ui_1.BreadCrumb, null,
                        props.currentProject ? (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id) }, props.currentProject.name)) : (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage) }, "SokoPro")),
                        props.currentProject && (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite") }, (0, translation_1.getLocalization)('breadcrumb/sokosite'))),
                        props.currentProject &&
                            props.currentWorksiteDiary &&
                            props.currentWorksiteDiary.name && (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite/worksitediary/").concat(props.currentWorksiteDiary.diary_uuid) }, "".concat((0, translation_1.getLocalization)('breadcrumb/worksiteDiary'), ": ").concat(props.currentWorksiteDiary.name),
                            props.currentWorksiteDiary.site_number
                                ? " - ".concat(props.currentWorksiteDiary.site_number)
                                : '')),
                        React.createElement("span", null, (0, translation_1.getLocalization)('diaryEntriesView/entries')),
                        props.currentProject &&
                            props.currentEntry &&
                            props.currentEntry.ui_diary_date && (React.createElement("span", null, props.currentEntry.ui_diary_date))),
                    props.updateProgress === 'FETCHING' ||
                        props.updateProgress === 'UPDATING' ? (React.createElement("div", { className: "loading-spinner-container" },
                        React.createElement(sok_ui_1.LoadingSpinner, null))) : (React.createElement(React.Fragment, null,
                        !props.isMobile || props.viewport.size === 'TABLET' ? (React.createElement("div", { className: "card-container" },
                            React.createElement("div", { className: "card-box" },
                                React.createElement("h2", null, (0, translation_1.getLocalization)('worksitediary')),
                                React.createElement("div", { className: "info-box card-box-content" },
                                    React.createElement("div", { className: "meta-info" },
                                        React.createElement("div", { className: 'row' },
                                            React.createElement("div", { className: 'column card' },
                                                React.createElement("span", { className: 'column-icon' },
                                                    React.createElement("i", { className: 'fa fa-user' })),
                                                React.createElement("div", { className: 'card-inner' },
                                                    React.createElement("div", { className: "meta-title" }, (0, translation_1.getLocalization)('diaryEntryView/header/workSite')),
                                                    React.createElement("div", { className: "meta-content" }, props.currentWorksiteDiary && (React.createElement("div", null,
                                                        props.currentWorksiteDiary.name,
                                                        props.currentWorksiteDiary.site_number
                                                            ? " / ".concat(props.currentWorksiteDiary.site_number)
                                                            : ''))))),
                                            React.createElement("div", { className: 'column card' },
                                                React.createElement("span", { className: 'column-icon' },
                                                    React.createElement("i", { className: 'fa fa-calendar' })),
                                                React.createElement("div", { className: 'card-inner' },
                                                    React.createElement("div", { className: "meta-title" }, (0, translation_1.getLocalization)('diaryEntryView/header/weekYear')),
                                                    React.createElement("div", { className: "meta-content" }, props.currentEntry &&
                                                        props.currentEntry.diary_date && (React.createElement("div", null,
                                                        moment(props.currentEntry.diary_date).week(),
                                                        "/",
                                                        moment(props.currentEntry.diary_date).year()))))),
                                            React.createElement("div", { className: 'column card' },
                                                React.createElement("span", { className: 'column-icon' },
                                                    React.createElement("i", { className: 'fa fa-calendar' })),
                                                React.createElement("div", { className: 'card-inner' },
                                                    React.createElement("div", { className: "meta-title" }, (0, translation_1.getLocalization)('diaryEntryView/header/date')),
                                                    React.createElement("div", { className: "meta-content" }, props.currentEntry &&
                                                        props.currentEntry.diary_date && (React.createElement("div", null, moment(props.currentEntry.diary_date).format('DD.MM.YYYY')))))),
                                            React.createElement("div", { className: 'column card' },
                                                React.createElement("span", { className: 'column-icon' },
                                                    React.createElement("i", { className: 'fa fa-file' })),
                                                React.createElement("div", { className: 'card-inner' },
                                                    React.createElement("div", { className: "meta-title" }, (0, translation_1.getLocalization)('diaryEntryView/header/workdayPage')),
                                                    React.createElement("div", { className: "meta-content" }, props.currentEntry &&
                                                        props.currentEntry.workday && (React.createElement("div", null, props.currentEntry.workday))))))))))) : (React.createElement("div", { className: "card-container" },
                            React.createElement("div", { className: "card-box" },
                                React.createElement(sok_ui_1.AccordionPanel, { title: (0, translation_1.getLocalization)('worksitediary') },
                                    React.createElement("div", { className: "info-box card-box-content" },
                                        React.createElement("div", { className: "meta-info-mobile" },
                                            React.createElement("div", { className: 'row' },
                                                React.createElement("div", { className: 'column card' },
                                                    React.createElement("div", { className: 'card-inner' },
                                                        React.createElement("div", { className: "meta-title" }, (0, translation_1.getLocalization)('diaryEntryView/header/workSite') + ':'),
                                                        React.createElement("div", { className: "meta-content" }, props.currentWorksiteDiary && (React.createElement("div", null,
                                                            props.currentWorksiteDiary.name,
                                                            props.currentWorksiteDiary.site_number
                                                                ? " / ".concat(props.currentWorksiteDiary.site_number)
                                                                : ''))))),
                                                React.createElement("div", { className: 'column card' },
                                                    React.createElement("div", { className: 'card-inner' },
                                                        React.createElement("div", { className: "meta-title" }, (0, translation_1.getLocalization)('diaryEntryView/header/weekYear') + ':'),
                                                        React.createElement("div", { className: "meta-content" }, props.currentEntry &&
                                                            props.currentEntry.diary_date && (React.createElement("div", null,
                                                            moment(props.currentEntry.diary_date).week(),
                                                            "/",
                                                            moment(props.currentEntry.diary_date).year()))))),
                                                React.createElement("div", { className: 'column card' },
                                                    React.createElement("div", { className: 'card-inner' },
                                                        React.createElement("div", { className: "meta-title" }, (0, translation_1.getLocalization)('diaryEntryView/header/date') + ':'),
                                                        React.createElement("div", { className: "meta-content" }, props.currentEntry &&
                                                            props.currentEntry.diary_date && (React.createElement("div", null, moment(props.currentEntry.diary_date).format('DD.MM.YYYY')))))),
                                                React.createElement("div", { className: 'column card' },
                                                    React.createElement("div", { className: 'card-inner' },
                                                        React.createElement("div", { className: "meta-title" }, (0, translation_1.getLocalization)('diaryEntryView/header/workdayPage') + ':'),
                                                        React.createElement("div", { className: "meta-content" }, props.currentEntry &&
                                                            props.currentEntry.workday && (React.createElement("div", null, props.currentEntry.workday)))))))))))),
                        React.createElement("div", { className: "card-wrapper-accordion" }, weatherInfo && (React.createElement(WeatherSection_1.default, { weatherInfo: weatherInfo, setWeatherInfo: setWeatherInfo, currentEntry: props.currentEntry, isMobile: props.isMobile && props.viewport.size !== 'TABLET', viewportSize: props.viewport.size, isDisabled: disableFieldsHelper() }))),
                        React.createElement("div", { className: "card-wrapper-accordion employee-and-equipment" },
                            React.createElement(CardBox_1.CardBox, { title: "employee" },
                                React.createElement("div", { className: "employee-button" },
                                    React.createElement(sok_ui_1.Button, { icon: React.createElement(sok_ui_1.Icon, { className: 'fa-plus' }), color: 'green', disabled: disableFieldsHelper(), text: (0, translation_1.getLocalization)('diaryEntryView/accordion/add'), size: "large", onClick: function () {
                                            setShowEmployee(true);
                                        } })),
                                React.createElement("div", { className: "employee-input-box", style: longerEmployees ? {} : { display: 'flex' } }, employees.map(function (item, i) { return (React.createElement("div", { className: longerEmployees
                                        ? 'employee-input max-w-100'
                                        : 'employee-input' },
                                    React.createElement(CountInput_1.default, { item: item, index: i, disabled: disableFieldsHelper(), setCount: setEmployeeCount, openModal: function () { return setEditEmployee(true); }, setCurrentInput: setCurrentInput, isMobile: props.isMobile || props.viewport.size === 'TABLET' }))); })),
                                React.createElement("div", { className: "total" },
                                    React.createElement("div", { className: "total-text" },
                                        (0, translation_1.getLocalization)('diaryEntryView/total'),
                                        ":",
                                        ' ',
                                        employeeCount)),
                                React.createElement(NewInputModal_1.default, __assign({ closeModal: function () { return setShowEmployee(false); }, show: showEmployee, addFunction: addEmployee, localizationPrefix: 'employees' }, props)),
                                React.createElement(EditInputModal_1.default, __assign({ closeModal: function () { return setEditEmployee(false); }, open: showEditEmployee, initialName: currentInput ? currentInput.name : '', initialCount: currentInput ? currentInput.count : 1, currentIndex: currentInput ? currentInput.index : undefined, editInput: editEmployee, localizationPrefix: 'employees' }, props))),
                            React.createElement(CardBox_1.CardBox, { title: "equipment" },
                                React.createElement("div", { className: "equipment-button" },
                                    React.createElement(sok_ui_1.Button, { icon: React.createElement(sok_ui_1.Icon, { className: 'fa-plus' }), color: 'green', disabled: disableFieldsHelper(), text: (0, translation_1.getLocalization)('diaryEntryView/accordion/add'), size: "large", onClick: function () {
                                            setShowEquipment(true);
                                        } })),
                                React.createElement("div", { className: "equipment-input-box", style: longerEquipments ? {} : { display: 'flex' } }, equipments.map(function (item, i) { return (React.createElement("div", { className: longerEquipments
                                        ? 'equipment-input max-w-100'
                                        : 'equipment-input' },
                                    React.createElement(CountInput_1.default, { item: item, index: i, disabled: disableFieldsHelper(), setCount: setEquipmentCount, openModal: function () { return setEditEquipment(true); }, setCurrentInput: setCurrentInput, isMobile: props.isMobile || props.viewport.size === 'TABLET' }))); })),
                                React.createElement("div", { className: "total" },
                                    React.createElement("div", { className: "total-text" },
                                        (0, translation_1.getLocalization)('diaryEntryView/total'),
                                        ":",
                                        ' ',
                                        equipmentsCount)),
                                React.createElement(NewInputModal_1.default, __assign({ closeModal: function () { return setShowEquipment(false); }, show: showEquipment, addFunction: addEquipment, localizationPrefix: 'equipments' }, props)),
                                React.createElement(EditInputModal_1.default, __assign({ closeModal: function () { return setEditEquipment(false); }, open: showEditEquipment, initialName: currentInput ? currentInput.name : '', initialCount: currentInput ? currentInput.count : 1, currentIndex: currentInput ? currentInput.index : undefined, editInput: editEquipment, localizationPrefix: 'equipments' }, props)))),
                        React.createElement(WorksiteStatus_1.WorksiteStatus, { perm: perm, diaryId: props.match.params.id, entryId: props.match.params.uuid, jobs: props.jobsList, setJobsList: props.setJobsList, currentEntry: props.currentEntry, currentWorksiteDiary: props.currentWorksiteDiary, isDisabled: disableFieldsHelper(), isMobile: props.isMobile, viewportSize: props.viewport.size }),
                        React.createElement("div", { className: "card-wrapper-accordion" },
                            React.createElement(CardBox_1.CardBox, { title: "plan", toggled: getInitialAccordionStateForKey(props.currentEntry, 'plan_info') },
                                React.createElement(sok_ui_1.TextInput, { name: "planInfo", defaultValue: props.currentEntry ? props.currentEntry.plan_info : '', type: "textarea", rows: 6, onChange: function (e) {
                                        handleChange(e);
                                    }, disabled: disableFieldsHelper() })),
                            React.createElement(CardBox_1.CardBox, { title: "review", toggled: getInitialAccordionStateForKey(props.currentEntry, 'review_info') },
                                React.createElement(sok_ui_1.TextInput, { name: "reviewInfo", defaultValue: props.currentEntry ? props.currentEntry.review_info : '', type: "textarea", rows: 6, onChange: function (e) {
                                        handleChange(e);
                                    }, disabled: disableFieldsHelper() })),
                            React.createElement(CardBox_1.CardBox, { title: "smallChanges", toggled: getInitialAccordionStateForKey(props.currentEntry, 'small_critical_changes') },
                                React.createElement(sok_ui_1.TextInput, { name: "smallChanges", defaultValue: props.currentEntry
                                        ? props.currentEntry.small_critical_changes
                                        : '', type: "textarea", rows: 6, onChange: function (e) {
                                        handleChange(e);
                                    }, disabled: disableFieldsHelper() })),
                            React.createElement(CardBox_1.CardBox, { title: "changeOffers", toggled: getInitialAccordionStateForKey(props.currentEntry, 'change_offers') },
                                React.createElement(sok_ui_1.TextInput, { name: "changeOffers", defaultValue: props.currentEntry
                                        ? props.currentEntry.change_offers
                                        : '', type: "textarea", rows: 6, onChange: function (e) {
                                        handleChange(e);
                                    }, disabled: disableFieldsHelper() })),
                            React.createElement(CardBox_1.CardBox, { title: "additionalTime", toggled: getInitialAccordionStateForKey(props.currentEntry, 'additional_time') },
                                React.createElement(sok_ui_1.TextInput, { name: "additionalTime", defaultValue: props.currentEntry
                                        ? props.currentEntry.additional_time
                                        : '', type: "textarea", rows: 6, onChange: function (e) {
                                        handleChange(e);
                                    }, disabled: disableFieldsHelper() })),
                            React.createElement(CardBox_1.CardBox, { title: "additionalNotes", toggled: getInitialAccordionStateForKey(props.currentEntry, 'additional_notes') },
                                React.createElement(sok_ui_1.TextInput, { name: "additionalNotes", defaultValue: props.currentEntry
                                        ? props.currentEntry.additional_notes
                                        : '', type: "textarea", rows: 6, onChange: function (e) {
                                        handleChange(e);
                                    }, disabled: disableFieldsHelper() })),
                            React.createElement(CardBox_1.CardBox, { title: "otherNotes", toggled: getInitialAccordionStateForKey(props.currentEntry, 'other_notes') },
                                React.createElement(sok_ui_1.TextInput, { name: "otherNotes", defaultValue: props.currentEntry ? props.currentEntry.other_notes : '', type: "textarea", rows: 6, onChange: function (e) {
                                        handleChange(e);
                                    }, disabled: disableFieldsHelper() })),
                            React.createElement(CardBox_1.CardBox, { title: "supervisor", toggled: getInitialAccordionStateForKey(props.currentEntry, 'supervisor_notes') },
                                React.createElement(sok_ui_1.TextInput, { name: "supervisorNotes", defaultValue: props.currentEntry
                                        ? props.currentEntry.supervisor_notes
                                        : '', type: "textarea", rows: 6, onChange: function (e) {
                                        handleChange(e);
                                    }, disabled: (acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT) ||
                                        acl.hasGrant(worksiteDiaryPerm, acl.WORKSITE_DIARY_SUPERVISOR_GRANT)) &&
                                        props.currentEntry &&
                                        props.currentEntry.supervisor_signature === ''
                                        ? false
                                        : true }))),
                        React.createElement(Images_1.default, { images: props.images, imagesStatus: props.imagesStatus, filesCrudStatus: props.filesCrudStatus, isMobile: props.isMobile, viewportSize: props.viewport.size, isDisabled: (acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT) ||
                                acl.hasGrant(worksiteDiaryPerm, acl.WORKSITE_DIARY_MASTER_GRANT)) &&
                                props.currentEntry &&
                                props.currentEntry.master_signature === ''
                                ? false
                                : true, handleOnDeleteClick: function (fileToDelete) {
                                setConfirmDialogData({
                                    title: 'worksitediary/attachments/deleteConfirmTitle',
                                    text: 'worksitediary/attachments/deleteConfirmDescription',
                                    onConfirm: function () {
                                        if (fileToDelete) {
                                            props.deleteFiles([fileToDelete]);
                                        }
                                        props.setConfirmDialogOpen(false);
                                    }
                                });
                                props.setConfirmDialogOpen(true);
                            }, handleUpload: function () {
                                if (props.currentEntry &&
                                    props.currentEntry.images_folder &&
                                    props.currentEntry.images_folder.type === 'FOLDER') {
                                    props.setUploadFolder(props.currentEntry.images_folder);
                                }
                                setAcceptFileTypes('image/png, image/gif, image/jpeg');
                                props.toggleUploadReplace(false);
                                props.toggleUnzip(true);
                                props.toggleUploadModal();
                            }, setAcceptFileTypes: setAcceptFileTypes, handleEdit: setImagePropertiesFile }),
                        React.createElement(Attachments_1.default, { attachments: props.attachments, attachmentsStatus: props.attachmentsStatus, filesCrudStatus: props.filesCrudStatus, isMobile: props.isMobile, viewportSize: props.viewport.size, isDisabled: (acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT) ||
                                acl.hasGrant(worksiteDiaryPerm, acl.WORKSITE_DIARY_MASTER_GRANT)) &&
                                props.currentEntry &&
                                props.currentEntry.master_signature === ''
                                ? false
                                : true, handleOnDeleteClick: function (deleteFileWithUuid) {
                                setConfirmDialogData({
                                    title: 'worksitediary/attachments/deleteConfirmTitle',
                                    text: 'worksitediary/attachments/deleteConfirmDescription',
                                    onConfirm: function () {
                                        var selectedFile = props.attachments.find(function (x) { return x.uuid === deleteFileWithUuid; });
                                        if (selectedFile) {
                                            props.deleteFiles([selectedFile]);
                                        }
                                        props.setConfirmDialogOpen(false);
                                    }
                                });
                                props.setConfirmDialogOpen(true);
                            }, handleUpload: function () {
                                if (props.currentEntry &&
                                    props.currentEntry.folder &&
                                    props.currentEntry.folder.type === 'FOLDER') {
                                    props.setUploadFolder(props.currentEntry.folder);
                                    setAcceptFileTypes(undefined);
                                }
                                props.toggleUploadReplace(false);
                                props.toggleUnzip(true);
                                props.toggleUploadModal();
                            } }),
                        React.createElement(CardBox_1.CardBox, { title: "signatures" },
                            React.createElement("div", { className: "card-box-content signature-content" },
                                React.createElement("div", { className: "signature-item" },
                                    React.createElement("h3", null, "".concat((0, translation_1.getLocalization)('diaryEntryView/signatures/master'), ": ")),
                                    React.createElement("p", null, props.currentEntry &&
                                        props.currentEntry.master_signature &&
                                        props.currentEntry.master_signature !== ''
                                        ? (0, ListContainer_1.signatureInLocalTime)(props.currentEntry.master_signature)
                                        : ''),
                                    props.currentEntry &&
                                        props.currentEntry.master_signature === '' ? (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('diaryEntryView/signatures/sign/master/tooltip')) },
                                        React.createElement(sok_ui_1.Button, { className: 'sign-button', type: 'submit', color: 'blue', text: (0, translation_1.getLocalization)('diaryEntryView/signatures/sign'), iconRight: React.createElement(sok_ui_1.Icon, { className: "fas fa-signature" }), disabled: (acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT) ||
                                                acl.hasGrant(worksiteDiaryPerm, acl.WORKSITE_DIARY_MASTER_GRANT)) &&
                                                props.currentEntry &&
                                                props.currentEntry.master_signature === ''
                                                ? false
                                                : true, onClick: function (e) {
                                                e.preventDefault();
                                                if (props.currentEntry) {
                                                    checkFieldsAndUpdateEntry(props, true);
                                                }
                                            } }))) : ('')),
                                React.createElement("div", { className: "signature-item" },
                                    React.createElement("h3", null, "".concat((0, translation_1.getLocalization)('diaryEntryView/signatures/supervisor'), ": ")),
                                    React.createElement("p", null, props.currentEntry &&
                                        props.currentEntry.supervisor_signature &&
                                        props.currentEntry.supervisor_signature !== ''
                                        ? (0, ListContainer_1.signatureInLocalTime)(props.currentEntry.supervisor_signature)
                                        : ''),
                                    props.currentEntry &&
                                        props.currentEntry.supervisor_signature === '' ? (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('diaryEntryView/signatures/sign/supervisor/tooltip')) },
                                        React.createElement(sok_ui_1.Button, { className: 'sign-button', type: 'submit', color: 'blue', text: (0, translation_1.getLocalization)('diaryEntryView/signatures/sign'), iconRight: React.createElement(sok_ui_1.Icon, { className: "fas fa-signature" }), disabled: (acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT) ||
                                                acl.hasGrant(worksiteDiaryPerm, acl.WORKSITE_DIARY_SUPERVISOR_GRANT)) &&
                                                props.currentEntry &&
                                                props.currentEntry.master_signature !== '' &&
                                                props.currentEntry.supervisor_signature === ''
                                                ? false
                                                : true, onClick: function (e) {
                                                e.preventDefault();
                                                if (props.currentEntry) {
                                                    checkFieldsAndUpdateEntry(props, false, true);
                                                }
                                            } }))) : ('')))),
                        React.createElement("div", { className: "card-box-comments" },
                            React.createElement(Comments_1.default, { perm: perm ? perm : 0x00, worksiteDiaryPerm: worksiteDiaryPerm ? worksiteDiaryPerm : 0x00, diaryId: props.match.params.id, entryId: props.match.params.uuid, isMobile: props.isMobile })))),
                    React.createElement(NavigateConfirmation_1.default, { display: !disableSaveButtonHelper(), firstRow: (0, translation_1.getLocalization)('worksitediary/images/closeWithoutSavingConfirmTitle'), secondRow: (0, translation_1.getLocalization)('worksitediary/images/closeWithoutSavingConfirmDescription') }),
                    !props.isMobile && React.createElement(sok_ui_1.Footer, null, menuButtons))))));
});
